import React from 'react';
import { Box, Typography, Grid, Button, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';

const Sponsors = () => {
  const sponsors = [
    {
      name: '<a href="https://www.himal.fi/" target="_blank" rel="noopener noreferrer" style="text-decoration: none;color: inherit;">WHITE HIMAL</a>',
      logo: '/sponsors/white_himal.jpg',
      description:
        'White Himal Restaurant – Proud Sponsor of Mirmire Sporting Club. Located in the heart of Tikkurila (Talvikkitie 37, Vantaa), White Himal is a modern Nepalese fine dining restaurant known for its authentic flavors, warm hospitality, and cozy atmosphere. Their diverse menu features traditional Nepalese favorites such as Chicken Tikka Masala, Butter Chicken, and Palak Paneer – all served with fresh naan and rice. Whether you are looking for a delicious lunch or a relaxed evening meal, White Himal offers a memorable culinary experience.<br/><br/>  We are proud to be supported by White Himal – a local business that values community and culture as much as we do.',
    },
    {
      name: 'FUTTA.FI',
      logo: '/sponsors/futta.jpg',
      description:
        'Futta.fi is a Helsinki-based moving service company that offers convenient and economical relocation solutions throughout Finland. Their services are designed to simplify the moving process, providing customers with a hassle-free experience.<br/><br/> As a proud sponsor of Mirmire Sporting Club, Futta.fi demonstrates its commitment to supporting local communities and organizations. Their partnership with the club reflects a shared dedication to teamwork, reliability, and excellence.<br/><br/> For more information or to book their services, you can contact Futta.fi via phone or WhatsApp at +358451812224.',
    },
  ];

  return (
    <>
      <Helmet>
        <title>Sponsors - Mirmire</title>
        <meta name="description" content="Our valued sponsors and partners" />
      </Helmet>

      {/* Header Section */}
      <Box
        sx={{
          bgcolor: '#000000',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: '#FFD700',
            fontWeight: 700,
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            textAlign: 'center',
          }}
        >
          SPONSORS
        </Typography>
      </Box>

      <Container maxWidth="lg">
        {/* Sponsors List Section */}
        <Box
          sx={{
            bgcolor: '#FFFFFF',
            py: { xs: 6, md: 8 },
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: '100%',
              px: 2,
            }}
          >
            {sponsors.map((sponsor, index) => (
              <Box
                key={index}
                sx={{
                  mb: 6,
                  pb: 6,
                  borderBottom: index !== sponsors.length - 1 ? '1px solid #E0E0E0' : 'none',
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  textAlign: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <Grid container spacing={4} alignItems="center">
                  <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box
                      sx={{
                        width: '100%',
                        maxWidth: '420px',
                        height: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto',
                      }}
                    >
                      <img
                        src={sponsor.logo}
                        alt={sponsor.name}
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                        loading="lazy"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                    <Typography
                      variant="h2"
                      sx={{
                        color: '#000000',
                        fontWeight: 700,
                        fontSize: '2rem',
                        mb: 2,
                        textDecoration: 'none',
                      }}
                      dangerouslySetInnerHTML={{ __html: sponsor.name }}
                    />
                    {sponsor.description && (
                      <Typography
                        sx={{
                          color: '#000000',
                          fontSize: '0.9rem',
                          lineHeight: 1.6,
                          mb: 3,
                        }}
                        dangerouslySetInnerHTML={{ __html: sponsor.description }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>

      {/* Sponsorship CTA Section */}
      <Box
        sx={{
          bgcolor: '#FFFFFF',
          py: { xs: 6, md: 8 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          borderTop: '1px solid #E0E0E0',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: '#000000',
            fontWeight: 700,
            fontSize: '2rem',
            mb: 4,
            textAlign: 'center',
          }}
        >
          INTERESTED IN SPONSORING US?
        </Typography>
        <Button
          variant="contained"
          component={RouterLink}
          to="/contact"
          sx={{
            bgcolor: '#000000',
            color: '#FFFFFF',
            px: 4,
            py: 1.5,
            fontSize: '1.1rem',
            '&:hover': {
              bgcolor: '#333333',
            },
          }}
        >
          CONTACT
        </Button>
      </Box>
    </>
  );
};

export default Sponsors;
